import HeartBoxColor from './HeartBoxColour.svg';
import HeartBoxDark from './HeartBoxDark.svg';
import HeartBoxLight from './HeartBoxLight.svg';
export const heartBox = { color: HeartBoxColor, dark: HeartBoxDark, light: HeartBoxLight };
//# sourceMappingURL=index.js.map